// extracted by mini-css-extract-plugin
export var headerCell = "_y-1";
export var loadingSpinnerContainer = "_y-4";
export var rowWrapper = "_y-3";
export var standaloneTable = "_y-5";
export var table = "_y-0";
export var white = "_y-2";